/** @format */

import React, {useEffect, useState} from 'react';
import {createPortal} from 'react-dom';
import PropTypes from 'prop-types';

export const Toast = props => {
    const {
        autoHideDuration = 2000,
        backgroundColor,
        autoHide,
        children,
        onClose,
        danger,
        isOpen,
        style,
        color,
        zIndex
    } = props;

    const [isVisible, setIsVisible] = useState(false);

    const handleClose = () => {
        setIsVisible(false);
        if (onClose) {
            onClose();
        }
    };

    useEffect(() => {
        setIsVisible(isOpen);
    }, [isOpen]);

    useEffect(() => {
        if (autoHide) {
            const timer = setTimeout(() => {
                handleClose();
            }, autoHideDuration);

            return () => clearTimeout(timer);
        }
    }, [autoHide, isOpen]);

    // Do not render the component if it is not visible
    if (!isVisible) {
        return null;
    }

    const bgColorClass = danger ? 'toast-11px--danger' : '';

    return createPortal(
        <div style={{...style, zIndex, backgroundColor}} className={`toast-11px ${bgColorClass}`}>
            <div>{children}</div>
            <button onClick={handleClose} className="toast-close-btn">
                <i className="fa fa-close" style={{color}} />
            </button>
        </div>,
        document.body
    );
};

// Prop types
Toast.propTypes = {
    autoHide: PropTypes.bool,
    autoHideDuration: PropTypes.number,
    backgroundColor: PropTypes.string,
    children: PropTypes.node.isRequired,
    color: PropTypes.string,
    danger: PropTypes.bool,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    style: PropTypes.object,
    zIndex: PropTypes.number
};
